module.exports = __webpack_public_path__ + "resources.png?594377b4a153b217100e2075468d97ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources.png
// module id = 83
// module chunks = 0